'use client'

import { useState, useEffect } from 'react'
import Link from 'next/link'

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/80 backdrop-blur-xl border-b border-black/5 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[980px] mx-auto px-6 h-14 flex items-center justify-between">
        <Link href="/" className="flex items-center gap-2 font-semibold text-lg">
          <span className="w-2 h-2 rounded-full bg-brand" />
          HeizWartung
        </Link>

        <div className="hidden md:flex items-center gap-6 text-sm text-gray-1">
          <Link href="/" className="hover:text-dark transition-colors">
            Startseite
          </Link>
          <Link href="/auftrag" className="hover:text-dark transition-colors">
            Mein Auftrag
          </Link>
          <Link
            href="/buchen"
            className="bg-dark text-white px-5 py-2 rounded-full text-sm font-medium
                       hover:bg-neutral-700 transition-colors"
          >
            Termin buchen
          </Link>
        </div>

        {/* Mobile CTA */}
        <Link
          href="/buchen"
          className="md:hidden bg-dark text-white px-4 py-2 rounded-full text-sm font-medium"
        >
          Buchen
        </Link>
      </div>
    </nav>
  )
}
